import CrudCustom from '../../../libs/custom/CrudCustom';

let PenyesuaianFiskalPositifService = new CrudCustom('/tipe-koreksi-fiskals');
export default PenyesuaianFiskalPositifService;
